import { useGetRoles } from '@vlabs/api/artemy/client';
import type { RoleId } from '@vlabs/api/artemy/model';
import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';

interface RoleCellProps {
  roleId: RoleId;
}

function RoleCell({ roleId }: RoleCellProps): React.JSX.Element {
  const getRoles = useGetRoles(
    { page_size: 1, role_ids: [roleId] },
  );

  const roleName = getRoles.data?.roles?.[0]?.name ?? roleId;

  return (
    <TruncatedText
      hasTruncation
      tooltipContent={roleName}
    >
      {roleName}
    </TruncatedText>
  );
}

export { RoleCell };
